import BaseSubMenu, {
  SubMenuProps as BaseSubMenuProps,
} from 'antd/lib/menu/SubMenu'

export interface SubMenuProps extends BaseSubMenuProps {}

export const SubMenu = (props: SubMenuProps): JSX.Element => (
  <>
    <BaseSubMenu {...props} />
  </>
)
